"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
function Ad(_a) {
    // if (process.env.NEXT_PUBLIC_STORYBOOK_ADS !== 'true') {
    //     return <></>
    // }
    var type = _a.type, keywords = _a.keywords, className = _a.className, _b = _a.mobile, mobile = _b === void 0 ? 'alpha' : _b;
    var leaderboard = type.includes('leaderboard');
    var MMDATA = { content: [keywords] };
    return react_1.default.createElement("div", { className: 'ads-ad' },
        react_1.default.createElement("div", { className: storybook_1.Helpers.classNames('ads-ad-wrapper', leaderboard ? 'ads-ad-leader' : '', className) },
            react_1.default.createElement("div", { id: "eyecons_ros_alpha_" + (type ? type : 'rectangle-halfpage') }),
            react_1.default.createElement("div", { id: "eyecons_ros_" + mobile + "_mobile" })));
}
exports.default = Ad;
Ad.propTypes = {
    /**
     * The style class
     */
    className: prop_types_1.default.string,
    /**
     * The Ad Type
     */
    type: prop_types_1.default.string,
    /**
     * The Ad Keywords
     */
    keywords: prop_types_1.default.string,
    /**
     * The mobile Ad slot
     */
    mobile: prop_types_1.default.string,
};
